import PropTypes from 'prop-types';
import clsx from 'clsx';

function Handle(props) {
  const { type, nodeId } = props;

  return <div data-node-id={nodeId} className={clsx('icp-workflow-handle', `${type}`)} />
}

Handle.propTypes = {
  nodeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.oneOf(['source', 'target']),
}

export default Handle;
